import React from 'react';
import { Link } from 'react-router-dom';
import { X, ArrowLeft } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function PaymentCancel() {
  return (
    <div className="bg-grain relative min-h-screen text-white">
      <Navbar />
      <div className="max-w-lg mx-auto pt-40 pb-20 px-6 text-center">
        <div className="mx-auto h-14 w-14 rounded-full bg-white/5 flex items-center justify-center text-white/60"><X className="h-8 w-8" /></div>
        <h1 className="font-display font-bold text-4xl mt-6 tracking-tight">Payment cancelled</h1>
        <p className="text-white/50 mt-3">No charge was made. You can complete your purchase anytime.</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Back to store
        </Link>
      </div>
      <Footer />
    </div>
  );
}
